import Cookies from 'js-cookie';

// See: Decoding signed cookies using JavaScript
// https://dev.to/ayushn21/demystifying-cookie-security-in-rails-6-1j2f
const decodeRailsSignedCookie = (signed) => {
    const raw = unescape(signed.split('--')[0]);
    const parsed = JSON.parse(atob(raw));

    // if it’s the new rails-wrapper format -- determined by
    // config.action_dispatch.use_cookies_with_metadata = true
    // https://github.com/rails/rails/pull/32937
    if (parsed._rails && parsed._rails.message) {
        const msgB64 = parsed._rails.message;

        const mod = msgB64.length % 4;
        const padLen = (4 - mod) % 4;
        const padded = msgB64
                .replace(/-/g, '+')
                .replace(/_/g, '/')
            + '=='.slice(0, padLen);

        const msgJson = atob(padded);

        return JSON.parse(msgJson);
    }

    // otherwise it’s the old-school payload right there
    return parsed;
};

export const anonToken = () => {
    const signedCookie = Cookies.get('anon_token_v1');
    if (signedCookie) {
        return decodeRailsSignedCookie(signedCookie);
    }
    if (window.SUPABASE_ANON_KEY) {
      return window.SUPABASE_ANON_KEY;
    }
    return null;
};

export const accessToken = () => {
    const signedCookie = Cookies.get('access_token_v1');
    if (signedCookie) {
        return decodeRailsSignedCookie(signedCookie);
    }
    return null;
};

export const authenticatedHeadersHash = () => {
    const hash = {};

    const accessTok = accessToken();
    if (accessTok) {
        hash.Authorization = `Bearer ${accessTok}`;
    }

    const anonTok = anonToken();
    if (!anonTok) {
        throw new Error('anon_token missing! This is required in order for the app to function.');
    }
    hash.apikey = anonTok;

    if (window.V2_SUPABASE_API_SCHEMA) {
        // Accept-Profile selects the schema for reads, Content-Profile for writes. Both are
        // needed: PostgREST falls back to `public` for a POST/PATCH sent without Content-Profile,
        // so an RPC call lands on a schema that holds none of our functions and answers 404
        // (PGRST202). Matches qwoted-rails views_shared/app/javascript/scripts/authentication.js,
        // which this file stands in for under the `views_shared/...` webpack alias.
        hash['Accept-Profile'] = window.V2_SUPABASE_API_SCHEMA;
        hash['Content-Profile'] = window.V2_SUPABASE_API_SCHEMA;
    }

    return hash;
};

export const anonHeadersHash = () => {
    const hash = {};

    const anonTok = anonToken();
    if (!anonTok) {
        throw new Error('anon_token missing! This is required in order for the app to function.');
    }
    hash.apikey = anonTok;
    hash.Authorization = `Bearer ${anonTok}`;

    if (window.V2_SUPABASE_API_SCHEMA) {
        // See authenticatedHeadersHash above for why both profile headers are set.
        hash['Accept-Profile'] = window.V2_SUPABASE_API_SCHEMA;
        hash['Content-Profile'] = window.V2_SUPABASE_API_SCHEMA;
    }

    return hash;
};
